import React, { useEffect, useRef, useState } from "react";
import "./frameStructureModal.scss";
import closeIcon from "../../../images/modal/close-icon.svg";
import useOnClickOutside from "../../../helpers/useOnClickOutside";
import FrameModalSidebar from "../../frameModalSidebar/FrameModalSidebar";
import { getIFrameById } from "../../iFrames/getIFrameById";
import { useDispatch } from "react-redux";
import { setIframeId } from "../../../redux/slices/statusSlice";

const FrameStructureModal = ({ isOpen, setIsOpen, structure }) => {
    const modalRef = useRef();
    let framesList = [];
    const dispatch = useDispatch();

    const [activeFrameId, setActiveFrameId] = useState(0);
    const [iFramesList, setIframesList] = useState([]);

    const getAllIframes = (structureArr) => {
        structureArr.forEach((structureItem) => {
            if ("file" in structureItem) {
                framesList.push(structureItem.file);
            } else {
                getAllIframes(structureItem.children);
            }
        });
    };

    useEffect(() => {
        if (iFramesList.length > 0) {
            const ids = [];
            iFramesList.forEach((frame) => {
                frame.iframes.forEach((currFrame, index) => {
                    ids.push(`${frame.id}-${index}`);
                });
            });
            const currentid = ids[activeFrameId];
            dispatch(setIframeId(currentid));
        }
    }, [iFramesList, activeFrameId]);

    useEffect(() => {
        if (structure) {
            framesList = [];
            getAllIframes(structure);
            setIframesList(framesList);
        }
    }, [structure]);

    useOnClickOutside(modalRef, () => setIsOpen(false));

    const scrollEvent = (e) => {
        setActiveFrameId(Math.round(e.target.scrollTop / 869));
    };

    const scrollToElementHandler = (id) => {
        document.getElementById(id).scrollIntoView({ behavior: "smooth" });
    };

    return (
        <>
            {isOpen && iFramesList && (
                <div className="modal-overlay">
                    <div className="frameStructureModal" ref={modalRef}>
                        <div className="modal-content" onScroll={scrollEvent}>
                            <img
                                src={closeIcon}
                                alt="close"
                                className="modal-content__close-btn"
                                onClick={() => setIsOpen(false)}
                            />
                            <div className="modal-content__sidebar">
                                <FrameModalSidebar
                                    scrollToElementHandler={scrollToElementHandler}
                                    setActiveFrameId={setActiveFrameId}
                                    activeFrameId={activeFrameId}
                                />
                            </div>
                            <div className="modal-content__iframe">
                                {iFramesList.map((frame) => {
                                    return frame.iframes.map((iFrameData, index) => {
                                        return (
                                            <div
                                                className="iframe-wrapper"
                                                id={`${frame.id}-${index}`}
                                                key={`${frame.id}-${index}`}
                                            >
                                                {getIFrameById(iFrameData.id, iFrameData, frame)}
                                            </div>
                                        );
                                    });
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default FrameStructureModal;
